import MuiDialog from '@mui/material/Dialog';
import { index, Options } from 'shared/assets/styles/z-index';
import styled, { css } from 'styled-components';

// Raised above the event popup: MUI's own dialog level sits *below* PopupMenu, so without
// this both the dialog and its backdrop render behind the popup that opened them.
// `&&` so this wins over the variant's own zIndex in the MUI theme overrides, which also
// targets the root with a single class
export const Dialog = styled(MuiDialog)<{ $abovePopups?: boolean }>`
  ${({ $abovePopups }) =>
    $abovePopups &&
    css`
      && {
        z-index: ${index(Options.POPUP_DIALOG)};
      }
    `};
`;

export const Header = styled.div`
  padding: ${({ theme }) =>
    `${theme.spacing(6)} ${theme.spacing(6)} ${theme.spacing(2)}`};
`;

export const Body = styled.div`
  padding: ${({ theme }) => `0 ${theme.spacing(6)} ${theme.spacing(6)}`};
`;

// Three actions plus Cancel do not fit side by side at this dialog width.
export const Footer = styled.div<{ $stacked?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => `0 ${theme.spacing(4)} ${theme.spacing(4)}`};

  ${({ $stacked }) =>
    $stacked &&
    css`
      flex-direction: column-reverse;
      align-items: stretch;

      button {
        width: 100%;
      }
    `};
`;

export const Interactions = styled.div<{ $stacked?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  ${({ $stacked }) =>
    $stacked &&
    css`
      flex-direction: column;
      align-items: stretch;
    `};
`;
